import * as React from 'react';

import PropTypes from 'prop-types';

import DiscussionsModal from 'bundles/discussions/components/DiscussionsModal';
import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/discussions';

class HighlightModal extends React.Component {
  static propTypes = {
    isHighlighted: PropTypes.bool,
    handleAccept: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isHighlighted' does not exist on type 'R... Remove this comment to see the full error message
    const { isHighlighted, handleAccept, handleCancel } = this.props;

    const modalName = isHighlighted ? _t('Unmark as Highlighted') : _t('Mark as Highlighted');
    const trackingName = isHighlighted ? 'unmark_as_highlighted' : 'mark_as_highlighted';

    return (
      <DiscussionsModal handleClose={handleCancel} modalName={modalName} trackingName={trackingName}>
        <h3 className="c-modal-title headline-3-text">{modalName}</h3>

        <div className="body-1-text">
          {!isHighlighted &&
            _t(
              `This will mark the post as "Highlighted" and duplicate it at the top of
            the page. There can only be one Highlighted Post so it will replace any previous one.
          `
            )}

          {isHighlighted &&
            _t(
              `This will remove the post from the top of the page but it will still be
            visible in the list of posts below.
          `
            )}
        </div>

        <div className="horizontal-box align-items-right" style={{ marginTop: 40 }}>
          <button className="secondary" onClick={handleCancel} type="button">
            {_t('Cancel')}
          </button>

          <TrackedButton
            className="primary"
            onClick={handleAccept}
            style={{ marginLeft: 20 }}
            trackingName={trackingName}
          >
            {isHighlighted ? _t('Unmark') : _t('Mark')}
          </TrackedButton>
        </div>
      </DiscussionsModal>
    );
  }
}

export default HighlightModal;
